/**
 * @namespace RewardStatusId
 * @description Defines the possible status identifiers for rewards in the system
 * @example
 * ```typescript
 * // Using a reward status ID in a query
 * const activeRewards = await repository.find({
 *   where: { statusId: RewardStatusId.Active }
 * });
 * ```
 */
export namespace RewardStatusId {
  /** ID for active rewards that are currently available to users */
  export const Active = 1n;
  /** ID for disabled rewards that are not currently available */
  export const Disabled = 2n;
}

/**
 * @type RewardStatusIdType
 * @description Type representing all possible reward status ID values
 * @remarks This type is derived from the RewardStatusId namespace and ensures type safety when working with reward status IDs
 */
export type RewardStatusIdType =
  (typeof RewardStatusId)[keyof typeof RewardStatusId];
